import { createReducer, on } from '@ngrx/store';
import { IProductsState, initialUIState } from './products.state';
import {
  loadProducts,
  loadProductsSuccess,
  loadProductsFailure,
  toggleProductsLoading,
} from './products.actions';

export const productsReducer = createReducer(
  initialUIState,
  on(loadProducts, (state) => ({
    ...state,
    loading: true,
  })),
  on(loadProductsSuccess, (state, { products }) => ({
    ...state,
    list: products,
    loading: false,
  })),
  on(loadProductsFailure, (state) => ({
    ...state,
    loading: false,
  })),
  on(toggleProductsLoading, (state, { loading }) => ({
    ...state,
    loading,
  }))
);